import { render, staticRenderFns } from "./LinksListGrid.vue?vue&type=template&id=877bc854&"
import script from "./LinksListGrid.vue?vue&type=script&lang=js&"
export * from "./LinksListGrid.vue?vue&type=script&lang=js&"
import style0 from "./LinksListGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports